var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/ImageFlipcardExtension.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { BaseImageFlipcard } from "../../db/extensions/BaseImageFlipcard.js";
import { ExtensionBoilerplate } from "./ContentExtensionBoilerplate.js";
import { ImageExtension } from "./ImageExtension.js";
var ImageFlipcardExtension = ({
  textExtension,
  imageExtension
}) => ({
  class: BaseImageFlipcard,
  toolbar: { icon: "flip", text: { default: "Bildbeschreibung" } },
  render(instance, { defaultValues, isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <x-image-flipcard-extension
        .textExtension=${textExtension}
        .imageExtension=${imageExtension}
        .content=${instance}
        .defaultValues=${defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-image-flipcard-extension>
    `;
  },
  editor({ content, contentController, controllerBaseKeyPath, host }) {
    return html`
      <x-flex space="lg">
        <x-flex space="md">
          <x-text tone="subtle"> Text: </x-text>
          ${textExtension?.editor?.({ content, contentController, controllerBaseKeyPath: ["imageText"], host })}
        </x-flex>
        <x-hr></x-hr>
        <x-flex space="md">
          <x-text tone="subtle"> Bild: </x-text>
          ${ImageExtension.editor?.({ content, contentController, controllerBaseKeyPath: ["file"], host })}
        </x-flex>
      </x-flex>
    `;
  },
  group: "Medien"
});
var XImageFlipcardExtension = class extends ExtensionBoilerplate {
  constructor() {
    super(...arguments);
    this._flipped = false;
  }
  _content(content) {
    return html`
      <div class="flip-card-inner">
        <div class="flip-card-front">
          <!-- image -->
          ${this.imageExtension?.render(content.file, {
      defaultValues: { width: { global: "100%" }, height: { global: "100%" }, objectFit: { global: "cover" } },
      isSubelement: true
    })}
          <!-- flip button -->
          ${this._flipButton()}
        </div>
        <div class="flip-card-back" ${css({ overflow: "hidden" })}>
          <!-- text -->
          <div
            class="flip-card-back-text-wrapper"
            ${css({ overflowY: "auto", maxHeight: "100%", boxSizing: "border-box", height: "100%" })}
          >
            ${this.textExtension?.render(content.imageText, { isSubelement: true })}
          </div>
          <!-- flip button -->
          ${this._flipButton()}
        </div>
      </div>
    `;
  }
  _flipButton() {
    return html`
      <x-icon
        ${css({
      position: "absolute",
      right: "16px",
      bottom: "16px",
      zIndex: "11",
      background: "#333",
      color: "#fff",
      cursor: "pointer",
      padding: "4px",
      borderRadius: this.defaultValue("borderRadius", { global: "5px" })
    })}
        @click=${() => {
      this._flipped = !this._flipped;
      const className = "flip-card-rotate";
      if (this.classList.contains(className))
        this.classList.remove(className);
      else
        this.classList.add(className);
    }}
      >
        content_copy
      </x-icon>
    `;
  }
  // we had issues with mozilla and rotations. That's why we need to define all explicit for moz again
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          perspective: "1000px",
          width: this.defaultValue("width", { global: "200px" }),
          height: this.defaultValue("height", { global: "auto" }),
          aspectRatio: this.defaultValue("aspectRatio", { global: "1 / 1" }),
          // moz specs
          MozPerspective: "1000px",
          MozWidth: this.defaultValue("width", { global: "200px" }),
          MozHeight: this.defaultValue("height", { global: "auto" }),
          MozAspectRatio: this.defaultValue("aspectRatio", { global: "1 / 1" })
        },
        ".flip-card-inner": {
          position: "relative",
          width: "100%",
          height: "100%",
          transition: "transform 0.6s",
          transformStyle: "preserve-3d",
          transform: this._flipped ? "rotateY(180deg)" : "",
          // moz specs
          MozPosition: "relative",
          MozWidth: "100%",
          MozHeight: "100%",
          MozTransition: "transform 0.6s",
          MozTransformStyle: "preserve-3d",
          MozTransform: this._flipped ? "rotateY(180deg)" : ""
        },
        ".flip-card-front, .flip-card-back": {
          position: "absolute",
          width: "100%",
          height: "100%",
          backfaceVisibility: "hidden",
          borderRadius: this.defaultValue("borderRadius", { global: "5px" }),
          overflow: "hidden",
          // moz specs
          MozPosition: "absolute",
          MozWidth: "100%",
          MozHeight: "100%",
          MozBackfaceVisibility: "hidden",
          MozBorderRadius: this.defaultValue("borderRadius", { global: "5px" }),
          MozOverflow: "hidden"
        },
        ".flip-card-front": {
          zIndex: "0",
          backgroundColor: "#bbb",
          color: "black",
          pointerEvents: this._flipped ? "none" : "",
          // moz specs
          MozBackgroundColor: "#bbb",
          MozColor: "black",
          MozPointerEvents: this._flipped ? "none" : ""
        },
        ".flip-card-back": {
          backgroundColor: this.defaultValue("backgroundColor", { global: "#f7f7f7" }),
          boxSizing: "border-box",
          padding: "24px",
          transform: "rotateY(180deg)",
          // moz specs
          MozBackgroundColor: this.defaultValue("backgroundColor", { global: "#f7f7f7" }),
          MozBoxSizing: "border-box",
          MozPadding: "24px",
          MozTransform: "rotateY(180deg)"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XImageFlipcardExtension.prototype, "imageExtension", 2);
__decorateClass([
  property({ attribute: false })
], XImageFlipcardExtension.prototype, "textExtension", 2);
__decorateClass([
  state()
], XImageFlipcardExtension.prototype, "_flipped", 2);
XImageFlipcardExtension = __decorateClass([
  customElement("x-image-flipcard-extension")
], XImageFlipcardExtension);
export {
  ImageFlipcardExtension,
  XImageFlipcardExtension
};
